import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c7cd2bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_page = _resolveComponent("ui-page")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_ui_card, null, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, { title: "报名活动" }, {
            right: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.operat()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新建活动")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_ui_table, {
            data: _ctx.source.list
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "登记名称",
                "min-width": "160"
              }),
              _createVNode(_component_el_table_column, {
                label: "报名费",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  (row.isPaid == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "¥" + _toDisplayString(row.price), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, "免费"))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "审核",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.isCheck == 1 ? '需审核' : '不需要'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "名额上限",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.maxCount === 0 ? '不限' : row.maxCount), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "状态",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(row.isEnabled == 1 ? 'status-on' : 'status-off')
                  }, _toDisplayString(row.isEnabled == 1 ? '启用' : '已停用'), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "创建时间",
                width: "170"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.$format(row.createTime)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "220",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    underline: false,
                    onClick: ($event: any) => (_ctx.record(row.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("报名记录")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_link, {
                    type: "primary",
                    underline: false,
                    style: {"margin-left":"10px"},
                    onClick: ($event: any) => (_ctx.operat(row.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("编辑")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_popconfirm, {
                    onConfirm: ($event: any) => (_ctx.delRow(row.id)),
                    title: "是否删除该活动？"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_link, {
                        type: "danger",
                        underline: false,
                        style: {"margin-left":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.source.loading]
          ]),
          _createVNode(_component_ui_page, {
            modelValue: _ctx.page.page,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page.page) = $event)),
            info: _ctx.pageInfo
          }, null, 8, ["modelValue", "info"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}